import { NgModule, Optional, SkipSelf } from "@angular/core";
import { RouterModule } from "@angular/router";

import { SharedModule } from "../shared/shared.module";

import { ConfirmDialogComponent } from "./confirm-dialog/confirm-dialog.component";
import { throwIfAlreadyLoaded } from "./module-import-guard";
import { SnackBarService } from "./snack-bar.service";
import { ThemeService } from "./theme.service";
import { ValidationHelperService } from "./validation-helper.service";
import { role, Role } from "./role.const";

@NgModule({
    imports: [
        RouterModule,
        SharedModule
    ],

    declarations: [
        ConfirmDialogComponent,
    ],

    exports: [
        ConfirmDialogComponent,
    ],

    entryComponents: [
        ConfirmDialogComponent
    ],

    providers: [
        SnackBarService,
        ThemeService,
        ValidationHelperService,

        { provide: role, useValue: Role }
    ]
})

export class CoreModule {
    constructor( @Optional() @SkipSelf() parentModule: CoreModule) {
        throwIfAlreadyLoaded(parentModule, "CoreModule");
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/core/core.module.ts